/// <reference path="../../../../node_modules/monaco-editor/monaco.d.ts" />
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, Output, ViewChild } from "@angular/core";

let loadedMonaco = false;
let loadPromise: Promise<void>;

/*
  Monaco Editor
  https://microsoft.github.io/monaco-editor/index.html
*/

@Component({
  standalone: false,
  selector: "monaco-diff-editor",
  templateUrl: "./monaco-diff-editor.component.html",
  styleUrls: ["./monaco-diff-editor.component.scss"],
})
export class MonacoDiffEditorComponent implements AfterViewInit {
  @ViewChild("editorContainer") editorContainer: ElementRef;

  @Input() code: string;
  @Input() language: string;
  @Input() theme: string;
  @Input() isReadonly: boolean;

  @Output() ready = new EventEmitter<monaco.editor.IStandaloneDiffEditor>();
  @Output() codeChange = new EventEmitter<String>();

  // Holds instance of the current code editor
  codeEditorInstance: monaco.editor.IStandaloneDiffEditor;

  constructor() {}

  ngAfterViewInit() {
    if (loadedMonaco) {
      // Wait until monaco editor is available
      loadPromise.then(() => {
        this.initMonaco();
      });
    } else {
      loadedMonaco = true;
      loadPromise = new Promise<void>((resolve: any) => {
        if (typeof (<any>window).monaco === "object") {
          resolve();
          return;
        }
        const onAmdLoader: any = () => {
          // Load monaco
          (<any>window).require.config({ paths: { vs: "/quota/assets/monaco/vs" } });

          (<any>window).require(["vs/editor/editor.main"], () => {
            this.initMonaco();
            resolve();
          });
        };

        // Load AMD loader if necessary
        if (!(<any>window).require) {
          const loaderScript: HTMLScriptElement = document.createElement("script");
          loaderScript.type = "text/javascript";
          loaderScript.src = "/quota/assets/monaco/vs/loader.js";
          loaderScript.addEventListener("load", onAmdLoader);
          document.body.appendChild(loaderScript);
        } else {
          onAmdLoader();
        }
      });
    }
  }

  initMonaco(): void {
    this.codeEditorInstance = monaco.editor.createDiffEditor(this.editorContainer.nativeElement, {
      theme: this.theme,
      readOnly: this.isReadonly,
      renderWhitespace: "boundary",
    });

    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
      allowComments: true,
    });

    this.ready.emit(this.codeEditorInstance);
  }
}
